const symetraConfig = Object.freeze({
    LABEL: 'Symetra Health',
    SHORT_LABEL: 'Symetra',
    NAME: 'symetra',
    PALETTE: {
        PRIMARY: '#0677D1',
        SECONDARY: '#5F9B1B'
    },
    CONTACT_SUPPORT: {
        EMAIL: 'symetrahealthsupport@joinansel.com',
        NUMBER: '(888) 384-3479',
        WEB_SITE: 'https://www.joinansel.com'
    },
    S3: {
        BASE_URL: 'https://joinansel-platform-assets.s3.amazonaws.com',
        SP_NAME: 'symetra',
        APPLICATION: 'enrollment',
    },
    LEGAL:{
        SERVICE_NAME: 'Ansel Services, Inc.',
        INSURANCE_NAME: 'Ansel Health, Inc.',
        TERMS: 'https://www.joinansel.com/terms',
        PRIVACY: 'https://www.joinansel.com/privacy-policy'
    },
});

export default symetraConfig;